import React, {useState, useEffect, useRef} from 'react';
import { useSelector } from 'react-redux';
import SarasPopup from '../../../library/container/popup/SarasPopup'
import SarasTrans from '../../../library/notifications/SarasTrans'
import useSarasStore from '../../../library/hooks/localDB/useSarasStore'
import {PhoneIphoneIcon} from '../../../library/decor/SarasIcons';
import SarasDialog from '../../../library/container/popup/SarasDialogDefAction';

const AppInstructionPopup = (props) => {
    const { appLink, targetRef, onClose } = props

    const handleClose = (event) => {
        // setOpen(false);
        onClose();
    };

    const cancelFun = () => {
        onClose();
    }

    return (
        <SarasPopup anchorRef={targetRef} open={true} onClose={handleClose}>
            <SarasDialog formStyle={{ width: '300px', height:'380px' }} 
                contentStyle={{ height:'280px', overflow:'hidden' }}  title={<SarasTrans value='Mobile App Instruction' />} 
                cancelName='Close' cancelFunction={cancelFun} >
                <div style={{ padding: '10px' }}>
                    <ul style={{ margin: '10px 0', padding: '5px' }}>
                        <li style={{ marginBottom: '14px' }}>Go to the App Store or Play Store and download the <b>SarasX Connect</b> app.</li>
                        <li style={{ marginBottom: '14px' }}>Open the app and scan the QR code given below from the login screen of the app.</li>
                        <li style={{ display: "flex", justifyContent: "center", marginBottom: "0" }}>
                            <img alt="" src={appLink} style={{ width: "150px" }} />
                        </li>
                    </ul>
                </div>
            </SarasDialog>
        </SarasPopup>
    )
}

const MobileApp=(props)=>{
    const { mobileAppActive, deviceInfo } = props
    const [popupName, setPopupName] = useState('');
    const [appLink, setAppLink] = useState('');
    const popupRef = useRef();
    const localDb = useSarasStore();
    var user = useSelector(state => state.auth.user);

    const checkAppQRLink = () => {
        if(!appLink)
        {
            //get selected culture
            localDb.requestData("app_qr_link", onAppLinkRetrieved);
        }
    };

    useEffect(checkAppQRLink, []);

    const onAppLinkRetrieved = (key, value) =>  {
        setAppLink(value);
    }

      const onShowAppInstructions = () => {
        setPopupName("show");
    }

    const onClose = () => {
        setPopupName("");
    }

    const renderPopup = () => {
        if (popupName === 'show') {
            return (
            <AppInstructionPopup targetRef={popupRef} 
                appLink={appLink}
                onClose={onClose} >
            </AppInstructionPopup>);
        }

        return null;
    }

    //if app link is not available, it means that mobile app is not configured
    if(!appLink || mobileAppActive === 0 
        || (user && user.HaveAppAccess === 0)) 
        {
            return null;
        }

    return(
        <>
            <span ref={popupRef} className='uiAppIconWithLink' onClick={onShowAppInstructions}>
                <PhoneIphoneIcon className='uiAppIcon'/>
                {!deviceInfo.activateMobileView && <span><SarasTrans value="App" /></span>}
            </span>

            {renderPopup()}
        </>
    )
}

export default MobileApp